import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Glyphicon } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class EntitiesList extends Component {
	constructor(props) {
		super(props);
		this.handleSort = this.handleSort.bind(this);
	}

	handleSort(selectedSortKey) {
		const { onFetchData, sortKey, sortDirection } = this.props;
		let selectedSortDirection = 'asc';
		if (selectedSortKey === sortKey) {
			selectedSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
		}
		onFetchData({
			sortKey: selectedSortKey,
			sortDirection: selectedSortDirection
		});
	}

	renderHeaderCell(column, index) {
		const headerText = column.header;
		let headerClick = null, headerIcon = null, headerStyle = null;

		if (column.sortable) {
			headerClick = () => this.handleSort(column.accessor);

			headerStyle = { cursor: 'pointer' };

			const { sortKey, sortDirection } = this.props;
			let headerIconStyle = { float: 'right', color: '#DDDDDD' }, headerIconGlyph = 'sort';
			if (sortKey === column.accessor) {
				headerIconStyle.color = '#707070';
				headerIconGlyph = sortDirection === 'asc' ? 'sort-by-attributes' : 'sort-by-attributes-alt';
			}
			headerIcon = <Glyphicon glyph={headerIconGlyph} style={headerIconStyle} />;
		}

		return (
			<th key={index} onClick={headerClick} style={headerStyle}>
				{headerText}{headerIcon}
			</th>
		);
	}

	renderDataCell(row, column, index) {
		let cellData = '', content = '';

		const { accessor, cell } = column;

		if (accessor) {
			if (typeof accessor === 'string')
				cellData = this.getNestedValue(row, accessor);

			if (typeof accessor === 'function')
				cellData = accessor(row);
		}

		content = cellData;

		if (cell) {
			content = cell(cellData, row);
		}

		return <td key={index}>{content}</td>;
	}

	getNestedValue(obj, key) {
		return key.split(".").reduce(function (result, key) {
			return result[key];
		}, obj);
	}

	render() {
		const { t, columns, data } = this.props;

		const headerCells = columns.map((column, index) => this.renderHeaderCell(column, index));
		const dataCells = row => columns.map((column, index) => this.renderDataCell(row, column, index));
		
		return (
			<Table responsive hover>
				<thead>
					<tr>{headerCells}</tr>
				</thead>
				<tbody>
					{(data && data.length) ? data.map((row, index) => <tr key={index}>{dataCells(row)}</tr>) :
							<tr><td colSpan={columns.length}>{t('List_Empty')}</td></tr>
					}
				</tbody>
			</Table >);
	}
}

EntitiesList.propTypes = {
	columns: PropTypes.arrayOf(PropTypes.shape({
		header: PropTypes.string,
		sortable: PropTypes.bool,
		accessor: PropTypes.string,
		cell: PropTypes.func
	})),
	onFetchData: PropTypes.func,
	data: PropTypes.array,
	sortKey: PropTypes.string,
	sortDirection: PropTypes.string
};

export default withTranslation()(EntitiesList);